import React from "react";
import "./Footer.css";
import logo from "../assets/logo.webp";
import { Helmet } from "react-helmet-async";
import fb from "../assets/fb.webp";
import insta from "../assets/insta.png";

function Footer() {
  return (
    <>
      {/* ================= SEO ================= */}
      <Helmet>
        <title>Modular Operation Theatre Experts in India | WEMS Pune</title>

        <meta
          name="description"
          content="WEMS (Wellness Electromedical Systems) provides modular operation theatre (OT) solutions, turnkey hospital setup, laminar airflow systems, ICU & cleanroom infrastructure across Pune and India."
        />

        <meta
          name="keywords"
          content="Modular OT India, Modular Operation Theatre Pune, Turnkey hospital setup India, OT installation Pune, Laminar airflow system, ICU setup India, hospital infrastructure company Pune, WEMS"
        />

        <link rel="canonical" href="https://www.wellnessmodularot.com/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Modular OT Experts India | WEMS Pune"
        />
        <meta
          property="og:description"
          content="Turnkey modular operation theatre, ICU, NICU, cleanroom & hospital infrastructure solutions in India."
        />
        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://www.wellnessmodularot.com/assets/wes-logo.png"
        />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Wellness Electromedical Systems (WEMS)",
            url: "https://www.wellnessmodularot.com/",
            logo: "https://www.wellnessmodularot.com/assets/wes-logo.png",
            description:
              "Leading provider of modular operation theatres, turnkey hospital setup, ICU, NICU, cleanroom and laminar airflow systems in India.",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Pune",
              addressRegion: "Maharashtra",
              addressCountry: "India",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-9665457825",
              contactType: "customer service",
            },
          })}
        </script>
      </Helmet>

      {/* ================= FOOTER UI (UNCHANGED) ================= */}
      <footer className="footer">
        {/* TOP BRAND AREA */}
        <div className="footer-top">
          <img
            src={logo}
            alt="WEMS Modular OT Company Logo"
            className="footer-logo"
          />
          <h2>Modular Operation Theatre Experts in India</h2>
          <p>
            Wellness Electromedical Systems Pvt. Ltd. (WEMS) delivers
            high-performance <strong>Modular OT solutions</strong>, laminar
            airflow systems, and turnkey hospital infrastructure across India.
          </p>
        </div>

        <div className="footer-container">
          {/* ABOUT */}
          <div className="footer-section about">
            <h3>About WEMS</h3>
            <p>
              Wellness Electromedical Systems is a leading provider of{" "}
              <strong>Modular Operation Theatre (OT)</strong>, ICU, NICU and
              cleanroom solutions with NABH-compliant designs.
            </p>
          </div>

          {/* SERVICES */}
          <div className="footer-section">
            <h3>Modular OT Services</h3>
            <ul>
              <li>Modular OT Design</li>
              <li>OT Installation</li>
              <li>Laminar Airflow Systems</li>
              <li>Hospital Infrastructure</li>
              <li>Turnkey OT Projects</li>
            </ul>
          </div>

          {/* LINKS */}
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/modular-ot">Modular OT</a>
              </li>
              <li>
                <a href="/modular-ot-services">Services</a>
              </li>
              <li>
                <a href="/modular-ot-gallery">Gallery</a>
              </li>
              <li>
                <a href="/hospital-projects">Projects</a>
              </li>
              <li>
                <a href="/contact-modular-ot">Contact</a>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="footer-section contact">
            <h3>Contact</h3>

            <p>Pune, Maharashtra, India</p>

            <p>
              📞 <a href="tel:+919665457825">+91-9665457825</a>
            </p>

            <p>
              📞 <a href="tel:+919579353053">+91-9579353053</a>
            </p>

            <p>
              ✉{" "}
              <a href="mailto:saleswellnessems@gmail.com">
                saleswellnessems@gmail.com
              </a>
            </p>

            <div className="footer-social">
              <a
                href="https://www.facebook.com/p/Wellness-Electromedical-Systems-Pvt-Ltd-100090175595703/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <img src={fb} alt="Facebook WEMS" />
              </a>

              <a
                href="https://www.instagram.com/wellness_electromedical_system?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img src={insta} alt="Instagram WEMS" />{" "}
              </a>
            </div>
          </div>
        </div>

        {/* CTA STRIP */}
        <div className="footer-cta">
          <p>Looking for Modular OT Setup?</p>
          <a href="/contact-modular-ot">Get Free Quote</a>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
         © 2026 Wellness Electromedical Systems Pvt. Ltd. (WEMS). All Rights Reserved.
          <span className="footer-dev">
            {" "}
            Designed & Developed by{" "}
            <a
              href="https://www.elevatedev.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Elevate Dev
            </a>
          </span>
        </div>
      </footer>
    </>
  );
}

export default Footer;
